import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SidebarContent } from './Sidebar';
import { darkThemeExtension, lightThemeExtension } from './chiTheme';

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent, lightThemeExtension, darkThemeExtension],
});
